module.exports = __webpack_public_path__ + "img/pl.25f96990.svg";